export default __webpack_public_path__ + "static/char-s-33-zh-Hans-479ef9a0e5525f2d025dfb8a3c003b37.png";